
import { Vue, Component } from 'vue-property-decorator';
import loginFormOverlayService from '@/project/modals/overlays/LoginFormOverlay.service';
import { UrlQueryKey } from '@/core/urlHelper.service';
import authService from '@/core/auth/auth.service';
import serverContextService from '@/core/serverContext.service';

@Component
export default class AuthenticationModule extends Vue {
    private checkForPasswordReset() {
        const params = new URLSearchParams(location.search);
        if (params.has('resetpassword')) {
            loginFormOverlayService.show('reset-pw', undefined, {
                singleton: true,
                closeOnBreakpointChange: false,
                closeOnRouteChange: false,
                disableUserClose: true
            });
        }
    }

    private checkForPasswordForgot() {
        const params = new URLSearchParams(location.search);
        if (params.has('forgotpassword')) {
            loginFormOverlayService.show('forgot-pw', undefined, {
                singleton: true,
                closeOnBreakpointChange: false,
                closeOnRouteChange: false,
                showCloseButton: true,
                disableUserClose: false
            });
        }
    }

    private checkForOciSession() {
        const params = new URLSearchParams(location.search);
        if (params.has(UrlQueryKey.ocisession) && serverContextService.ociToken) {
            authService.setToken(serverContextService.ociToken);
        }
    }

    render() {
        return undefined;
    }

    created() {
        this.checkForPasswordReset();
        this.checkForPasswordForgot();
        this.checkForOciSession();
    }
}
